import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/reevesdotnl/reevesdotnl/src/templates/pdf-view.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`With advancing years one is inclined to reflect on a career. Few geophysicists
have done so as  effectively as Norm Paterson. His new book tells the story of
how the now-familiar techniques of  geophysics in mineral exploration got
started in the 25 years following the end of the second World  War. It is a
fascinating history of scientific and technical creativity. Creative because no
one knew  for sure what would and would not work - in theory or practice - but
the ultimate goal of finding  hidden mineral deposits for a resource-hungry
world was rather obvious. Canada was centre stage for the innovations that
emerged, a situation that has survived another half century. `}</p>
    <p>{`From his text I see several ingredients that contributed to this success story.
The geophysics  laboratory (in reality a house) at the University of Toronto was
the spawning ground where so  many young students - and young war veterans - got
started on their career path. The  government in Ottawa, through the Geological
Survey of Canada, took a constructive role in  supporting systematic national
survey coverage that would never have happened if left to the  commercial sector
alone. The country as a whole had a 'can do' spirit that supported scientific
and  technical entrepreneurs who could invest their talents, time and money in
being geophysically  creative. The number of businesses, large and small, that
sprang up probably outnumbers the  talented individuals who made them work -
some of the time, at least. So it is actually to a small  number of individuals
that we owe the biggest debt of gratitude for the foundations of mining
geophysics - and not least to Norm himself. He provides cameos of most of the
pioneers, often  complete with amusing anecdotes about their human foibles. He
is uniquely well qualified to do  this in that he worked with many of them and
knew them all. His own geophysical career started  as a summer student on a
field camp in 1948. By now he is almost a lone survivor. How important  that he
has reminded us all that we stand on the shoulders of such giants! `}</p>
    <p>{`This essential reading is published by the Canadian Institute of Mining,
Metallurgy and Petroleum  at C$ 39.00. `}</p>
    <p><em parentName="p">{`2019 July 1 - Canada Day`}</em></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      